import { isFeatureEnabled } from 'Context/FeaturesContext/FeaturesContext.helpers';
import { FEATURES } from 'Context/FeaturesContext/FeaturesContextConsts';

let GA_USER = null;

export const GA_TRACKING_ID = 'G-4YPX2KLG4X';

export const event = ({
	action,
	...eventParams // eslint-disable-line camelcase
}) => {
	if (!window.gtag) return;
	const isAnalyticsEventLoggerEnabled = isFeatureEnabled(FEATURES.analyticsEventLogger);

	if (isAnalyticsEventLoggerEnabled) {
		// eslint-disable-next-line no-console
		console.info(action, {
			action,
			...eventParams,
		});
	}

	window.gtag('event', action, {
		...eventParams,
	});
};

export const setGAUser = (user) => {
	GA_USER = user;
};

export const initGAUserAndRecordInitialPageView = () => {
	if (!window.gtag) return;

	if (Number.isInteger(GA_USER?.id)) {
		const dealerId = GA_USER.dealerId?.toString();
		const contactId = GA_USER.id?.toString();

		// Set user properties for segmentation and drill-down
		window.gtag('set', 'user_properties', {
			contact_id: contactId,
			contact_name: GA_USER.name || '',
			dealer_id: dealerId,
			dealer_name: GA_USER.dealerName || '',
		});
	}

	window.gtag('event', 'page_view');
};

// --- GA4 custom events (upper-funnel engagement) ---

export const trackVehicleViewed = ({ enquiryId, vrm }) => {
	event({
		action: 'vehicle_viewed',
		enquiry_id: String(enquiryId),
		...(vrm && { vrm }),
	});
};

export const trackBidSubmitted = ({ enquiryId, vrm }) => {
	event({
		action: 'bid_submitted',
		enquiry_id: String(enquiryId),
		...(vrm && { vrm }),
	});
};

export const trackVehicleShortlisted = ({ enquiryId }) => {
	event({
		action: 'vehicle_shortlisted',
		enquiry_id: String(enquiryId),
	});
};
